// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2ngMF","rootSuccess":"CompleteLink_rootSuccess__2e-Fz","rootFailure":"CompleteLink_rootFailure__3VvXi","isDisabled":"CompleteLink_isDisabled__2r47D"};